import React, {Component} from "react";

class Events extends Component {
	render() {
		return (
			<div className="events">
				{this.props.children}
			</div>
		);
	}
}

export default Events;


// WEBPACK FOOTER //
// ./src/app/pages/LiveSoon/modules/Events.js